export class UserContextTreeResultDto {
    id: number;
    parentId: number;
    contextType: string;
    context: string;
    parentContext: string;
    title: string;
    isTerminated: boolean;
    isTransitionOnRamp: boolean;
    locationId: number;
    managementCompanyId: number;
    disabledSelection: boolean;

    // Transient fields
    selected = false;
    disabled = false;
    get communityId(): number {
        return this.context.startsWith('C') ? this.id : null;
    }
}
